import { Injectable } from "@angular/core";
import { ServiceProvider } from "./service.provider";
import { SchedulerBaseService } from "./scheduler.base.service";

@Injectable({
  providedIn: "root",
})
export class AccountService extends SchedulerBaseService {

  constructor(public provider: ServiceProvider) {
    super("api/accounts", provider);
  }

  public getAccount(id:string){
    return this.getList(`/${id}`);
  }

}